import React from 'react';

import type { CellProps } from 'react-table';
import type { PackageUtilizationExpectationListItem } from 'types';
import { capitalize } from 'utils/formatters';

import ActionsColumn from './ActionsColumn';

function formatExpectation(frequencyValue: string, frequencyUnit: 'week' | 'month' | 'year'): string {
  const numValue = parseFloat(frequencyValue);

  const formattedValue =
    numValue % 1 === 0 ? numValue.toString() : numValue.toFixed(2).replace(/\.?0+$/, '');

  return `${formattedValue} times per ${capitalize(frequencyUnit)}`;
}

const columns = [
  {
    Header: 'Packages',
    accessor: 'package.name',
  },
  {
    Header: 'Expectation',
    Cell: ({ row: { original } }: CellProps<PackageUtilizationExpectationListItem>) =>
      formatExpectation(original.frequencyValue, original.frequencyUnit),
  },
  {
    id: 'action',
    disableSortBy: true,
    Cell: ({ row }: CellProps<PackageUtilizationExpectationListItem>) => <ActionsColumn row={row} />,
  },
];

export default columns;
